document.addEventListener("DOMContentLoaded", function () {
  function updateTabsBehavior() {
    if (window.innerWidth > 989) {
      document
        .querySelector(".z_flex_grid .z_tab_button")
        .classList.add("z_active_tab");

      document.querySelectorAll(".z_tab_button").forEach(function (elem) {
        elem.addEventListener("click", function () {
          if (!this.classList.contains("z_active_tab")) {
            document.querySelectorAll(".z_tab_button").forEach(function (elem1) {
              elem1.classList.remove("z_active_tab");
            });
            document.querySelectorAll(".z_tab_content").forEach(function (elem1) {
              elem1.style.opacity = "0";
              elem1.style.display = "none";
            });
            this.classList.add("z_active_tab");
            let index = this.getAttribute("index");
            console.log("index", index);
            const targetContent = document.querySelector(
              `.z_tab_content:nth-child(${index})`
            );
            if (targetContent) {
              targetContent.style.opacity = "1";
              targetContent.style.display = "block";
            }
          }
        });
      });
    } else {
      document.querySelectorAll(".z_tab_button").forEach(function (elem) {
        elem.addEventListener("click", function () {
          if (!this.classList.contains("z_active_tab_accordian")) {
            document.querySelectorAll(".z_tab_button").forEach(function (elem2) {
              elem2.classList.remove("z_active_tab_accordian");
            });

            document.querySelectorAll(".z_tab_content").forEach(function (elem2) {
              elem2.style.maxHeight = "0";
              elem2.style.margin = "0";
            });

            this.classList.add("z_active_tab_accordian");

            let max_height = this.nextElementSibling.scrollHeight;
            this.nextElementSibling.style.opacity = "1";
            this.nextElementSibling.style.display = "block";
            this.nextElementSibling.style.maxHeight = max_height + "px";
            this.nextElementSibling.style.marginBottom = `24px`;
          } else {
            this.nextElementSibling.style.maxHeight = "0";
            this.nextElementSibling.style.margin = "0";
            this.classList.remove("z_active_tab_accordian");
          }
        });
      });
    }
  }

  function resetTabs() {
    document.querySelectorAll(".z_tab_button").forEach(function (elem) {
      elem.classList.remove("z_active_tab", "z_active_tab_accordian");
    });
    document.querySelectorAll(".z_tab_content").forEach(function (elem) {
      elem.style.maxHeight = "0";
      elem.style.opacity = "0";
      elem.style.display = "none";
      elem.style.margin = "0";
    });
  }

  updateTabsBehavior();

  window.addEventListener("resize", function () {
    console.log("max_height")
    resetTabs();
    updateTabsBehavior();

    if (window.innerWidth <= 989) {
      document.querySelectorAll(".z_active_tab_accordian").forEach(function (elem) {
        let max_height = elem.nextElementSibling.scrollHeight;
        console.log("max_height", max_height)
        elem.nextElementSibling.style.maxHeight = max_height + "px";
      });
    }
  });
});
